(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1233],{

/***/ 71922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ help; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/MenuList/index.ts + 5 modules
var MenuList = __webpack_require__(28536);
// EXTERNAL MODULE: ../../libs/matcha/components/SearchBar/index.ts + 1 modules
var SearchBar = __webpack_require__(54086);
// EXTERNAL MODULE: ../../node_modules/algoliasearch/dist/algoliasearch-lite.umd.js
var algoliasearch_lite_umd = __webpack_require__(43931);
var algoliasearch_lite_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite_umd);
// EXTERNAL MODULE: ../../node_modules/@algolia/autocomplete-core/dist/esm/createAutocomplete.js + 26 modules
var createAutocomplete = __webpack_require__(30888);
// EXTERNAL MODULE: ../../node_modules/@algolia/autocomplete-preset-algolia/dist/esm/requester/getAlgoliaResults.js + 5 modules
var getAlgoliaResults = __webpack_require__(22304);
// EXTERNAL MODULE: ../../node_modules/search-insights/index-browser.cjs.js
var index_browser_cjs = __webpack_require__(61759);
var index_browser_cjs_default = /*#__PURE__*/__webpack_require__.n(index_browser_cjs);
// EXTERNAL MODULE: ../../node_modules/@algolia/autocomplete-plugin-algolia-insights/dist/esm/createAlgoliaInsightsPlugin.js + 9 modules
var createAlgoliaInsightsPlugin = __webpack_require__(9965);
;// CONCATENATED MODULE: ../../libs/utils/useAutocomplete/useAutocomplete.ts


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var defaultResultsParams = {
  hitsPerPage: 10,
  facetFilters: ["hidden:-true"],
  clickAnalytics: true
};
/**
 * A hook to manage autocomplete for Algolia
 * @returns An object containing the autocompleteState (AutocompleteState from Algolia) and the autocomplete (result of createAutocomplete from Algolia)
 */

var useAutocomplete = function useAutocomplete(_ref) {
  var placeholder = _ref.placeholder,
      insightsInitParams = _ref.insightsInitParams,
      appId = _ref.appId,
      apiKey = _ref.apiKey,
      searchOptions = _ref.searchOptions,
      indexName = _ref.indexName,
      _ref$resultsParams = _ref.resultsParams,
      resultsParams = _ref$resultsParams === void 0 ? defaultResultsParams : _ref$resultsParams,
      sourceId = _ref.sourceId;
  index_browser_cjs_default()("init", _objectSpread({
    useCookie: true
  }, insightsInitParams));
  var plugins = (0,react.useMemo)(function () {
    var insightsPlugin = (0,createAlgoliaInsightsPlugin/* createAlgoliaInsightsPlugin */.Q)({
      insightsClient: (index_browser_cjs_default())
    });
    return [insightsPlugin];
  }, []);

  var _useState = (0,react.useState)(),
      autocompleteState = _useState[0],
      setAutocompleteState = _useState[1];

  var searchClient = (0,react.useMemo)(function () {
    return algoliasearch_lite_umd_default()(appId, apiKey, searchOptions);
  }, [apiKey, appId, searchOptions]);
  var autocomplete = (0,react.useMemo)(function () {
    return (0,createAutocomplete/* createAutocomplete */.l)({
      placeholder: placeholder,
      plugins: plugins,
      onStateChange: function onStateChange(_ref2) {
        var state = _ref2.state;
        setAutocompleteState(state);
      },
      getSources: function getSources() {
        return [{
          sourceId: sourceId,
          getItemInputValue: function getItemInputValue(_ref3) {
            var item = _ref3.item;
            return item.query;
          },
          getItems: function getItems(_ref4) {
            var query = _ref4.query;
            return (0,getAlgoliaResults/* getAlgoliaResults */.g)({
              searchClient: searchClient,
              queries: [{
                indexName: indexName,
                query: query,
                params: resultsParams
              }]
            });
          },
          getItemUrl: function getItemUrl(_ref5) {
            var item = _ref5.item;
            return item.url;
          }
        }];
      }
    });
  }, [indexName, placeholder, plugins, resultsParams, searchClient, sourceId]);
  return {
    autocompleteState: autocompleteState,
    autocomplete: autocomplete
  };
};

/* harmony default export */ var useAutocomplete_useAutocomplete = (useAutocomplete);
;// CONCATENATED MODULE: ../../libs/utils/useAutocomplete/index.ts

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Help/components/Autocomplete/Autocomplete.tsx




var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _process$env$NEXT_PUB3, _templateObject;

function Autocomplete_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Autocomplete_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Autocomplete_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Autocomplete_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var APP_ID = (_process$env$NEXT_PUB = "UINQ2M4D9S") !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "";
var API_KEY = (_process$env$NEXT_PUB2 = "31793145e4363fe43df8b46606b9e166") !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "";
var INDEX_NAME = (_process$env$NEXT_PUB3 = "segment-docs") !== null && _process$env$NEXT_PUB3 !== void 0 ? _process$env$NEXT_PUB3 : "";
var SOURCE_ID = "products";
var PLACEHOLDER_TEXT = "Search the knowledge base...";
var Autocomplete = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var name = _ref.name;
  var inputRef = (0,react.useRef)(null);
  (0,react.useImperativeHandle)(ref, function () {
    return inputRef.current;
  });

  var _useAutocomplete = useAutocomplete_useAutocomplete({
    insightsInitParams: {
      appId: APP_ID,
      apiKey: API_KEY
    },
    appId: APP_ID,
    apiKey: API_KEY,
    indexName: INDEX_NAME,
    sourceId: SOURCE_ID,
    placeholder: PLACEHOLDER_TEXT
  }),
      autocompleteState = _useAutocomplete.autocompleteState,
      autocomplete = _useAutocomplete.autocomplete;

  var highlight = (0,react.useCallback)(function (entry, variant) {
    if (autocompleteState !== null && autocompleteState !== void 0 && autocompleteState.query) {
      var parts = entry === null || entry === void 0 ? void 0 : entry.split(new RegExp(String.raw(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["(", ")"])), autocompleteState.query), "gi"));
      return parts === null || parts === void 0 ? void 0 : parts.map(function (part, i) {
        if (i % 2 === 0) {
          return part;
        }

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mark, {
          role: "mark",
          variant: variant,
          children: part
        }, "".concat(entry, "-").concat(i));
      });
    }
  }, [autocompleteState]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, Autocomplete_objectSpread(Autocomplete_objectSpread({}, autocomplete.getRootProps({})), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchBar/* default */.Z, Autocomplete_objectSpread(Autocomplete_objectSpread({
      name: name,
      ref: inputRef,
      "aria-label": PLACEHOLDER_TEXT
    }, autocomplete.getInputProps({
      inputElement: inputRef.current
    })), {}, {
      onClear: function onClear() {
        autocomplete.setQuery("");
        autocomplete.refresh();
      }
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Panel, Autocomplete_objectSpread(Autocomplete_objectSpread({}, autocomplete.getPanelProps({})), {}, {
      children: (autocompleteState === null || autocompleteState === void 0 ? void 0 : autocompleteState.isOpen) && autocompleteState.collections.map(function (collection) {
        var source = collection.source,
            items = collection.items;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuListWrapper, {
          children: items.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMenuListBase, Autocomplete_objectSpread(Autocomplete_objectSpread({
            interactive: true
          }, autocomplete.getListProps()), {}, {
            children: items.map(function (item) {
              var anchorLink = item.anchor ? "#".concat(item.anchor) : "";
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link, {
                href: "/docs".concat(item.url).concat(anchorLink),
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMenuListItem, Autocomplete_objectSpread(Autocomplete_objectSpread({}, autocomplete.getItemProps({
                  item: item,
                  source: source
                })), {}, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                      children: highlight(item.title, "title")
                    }), " / ", highlight(item.content, "content")]
                  })
                }))
              }, item.objectID);
            })
          }))
        }, collection.source.sourceId);
      })
    }))]
  }));
});
/* harmony default export */ var Autocomplete_Autocomplete = (Autocomplete);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "essr9377"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var Panel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "essr9376"
} : 0)( true ? {
  name: "1dnls4k",
  styles: "position:absolute;width:100%;top:58px"
} : 0);

var MenuListWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "essr9375"
} : 0)( true ? "" : 0);

var StyledMenuListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MenuList/* Item */.c,  true ? {
  target: "essr9374"
} : 0)("text-align:left;:hover{background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";}" + ( true ? "" : 0));

var Link = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "essr9373"
} : 0)( true ? {
  name: "tdvcnh",
  styles: "color:inherit;text-decoration:none"
} : 0);

var Mark = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("mark",  true ? {
  target: "essr9372"
} : 0)(function (_ref3) {
  var variant = _ref3.variant,
      theme = _ref3.theme;

  switch (variant) {
    case "title":
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("color:", theme.palette.twilio.gray[100], ";background:", theme.palette.twilio.gray[20], ";" + ( true ? "" : 0),  true ? "" : 0);

    case "content":
    default:
      return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("color:", theme.palette.twilio.green[60], ";background:none;" + ( true ? "" : 0),  true ? "" : 0);
  }
}, " font-weight:600;" + ( true ? "" : 0));

var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "essr9371"
} : 0)("color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.twilio.gray[60];
}, ";" + ( true ? "" : 0));

var StyledMenuListBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MenuList/* default */.Z,  true ? {
  target: "essr9370"
} : 0)( true ? {
  name: "1a6qgrx",
  styles: "position:absolute;z-index:2"
} : 0);
;// CONCATENATED MODULE: ./src/views/Help/components/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var copy = {
  heading: "What are you having trouble with?",
  description: "Browse our resources, search the knowledge base, or submit a ticket to our support team."
};

var Hero_Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroBase, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "h2",
          variant: "pLarge",
          children: copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Autocomplete_Autocomplete, {
          name: "help_page_query"
        })
      })]
    })
  });
};

var Hero_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "ejs12533"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* default */.ZP,  true ? {
  target: "ejs12532"
} : 0)(Hero/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:80px;}}" + ( true ? "" : 0));

var StyledHeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Copy */.CK,  true ? {
  target: "ejs12531"
} : 0)( true ? {
  name: "xvginl",
  styles: "max-width:600px"
} : 0);

var StyledHeroContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Hero/* Contents */.AU,  true ? {
  target: "ejs12530"
} : 0)( true ? {
  name: "1tl48zq",
  styles: "max-width:520px"
} : 0);

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/Help/components/Filters/Filters.tsx


function Filters_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var Filters = function Filters(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        columns: 1,
        overrides: {
          md: 3
        },
        gap: "small",
        children: children
      })
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e194irxv1"
} : 0)("overflow:visible;position:relative;z-index:1;", Section/* Wrapper */.im, "{padding:40px 24px;justify-content:center;}" + ( true ? "" : 0));

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e194irxv0"
} : 0)( true ? {
  name: "1teh2fl",
  styles: "row-gap:16px;justify-content:center;max-width:828px;margin:0 auto"
} : 0);

/* harmony default export */ var Filters_Filters = (Filters);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
;// CONCATENATED MODULE: ./src/views/Help/components/FilterSelect/FilterSelect.tsx



function FilterSelect_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FilterSelect_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FilterSelect_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FilterSelect_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function FilterSelect_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var FilterSelect = function FilterSelect(_ref) {
  var id = _ref.id,
      options = _ref.options,
      onSelect = _ref.onSelect,
      placeholder = _ref.placeholder;

  var _useSelect = (0,useSelect/* default */.Z)({
    options: options,
    id: id,
    onSelect: onSelect,
    config: {
      mobileConfirmationBehaviour: true
    },
    label: placeholder
  }),
      state = _useSelect.state,
      filteredOptions = _useSelect.filteredOptions,
      getControlProps = _useSelect.getControlProps,
      getSelectProps = _useSelect.getSelectProps;

  var selectId = "".concat(id, "-select");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FilterSelect_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, FilterSelect_objectSpread({
      name: id,
      type: "search",
      resetable: state.filterValue !== "",
      clearIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* ClearSelect */.kr, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
          size: "small"
        })
      }),
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {})
    }, getControlProps({
      placeholder: placeholder
    }))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, FilterSelect_objectSpread({
      id: selectId,
      name: selectId,
      open: state.open,
      options: options,
      filteredOptions: filteredOptions,
      displayMode: state.displayMode
    }, getSelectProps()))]
  });
};

var FilterSelect_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1cp6at20"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

/* harmony default export */ var FilterSelect_FilterSelect = (FilterSelect);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/Help/components/HelpGrid/HelpGrid.tsx


function HelpGrid_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var HelpGrid_copy = {
  noDataMessage: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: ["Sorry, we couldn't find a match for that. Try adjusting the filters above to expand the results.", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), " Can't find what you're looking for?"]
  })
};
var noDataLink = {
  text: "Schedule a call with a Segment team member here.",
  url: "/demo/"
};

var HelpGrid = function HelpGrid(_ref) {
  var data = _ref.data;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HelpGrid_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: data.length === 0 ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            children: HelpGrid_copy.noDataMessage
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
            href: (0,getAbsoluteUrl/* default */.Z)(noDataLink.url, pageConfig),
            children: noDataLink.text
          })]
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          columns: 1,
          overrides: {
            md: 2,
            xl: 3
          },
          children: data.map(function (_ref2) {
            var title = _ref2.title,
                description = _ref2.description,
                href = _ref2.href,
                Icon = _ref2.icon;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
              href: (0,getAbsoluteUrl/* default */.Z)(href, pageConfig),
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                      variant: "transparent",
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                        size: "large"
                      })
                    })
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                    variant: "h4",
                    tag: "h2",
                    children: title
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                    variant: "pLarge",
                    children: description
                  })]
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                  alignment: "right",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
                })]
              })
            }, title);
          })
        })
      })
    })
  });
};

var HelpGrid_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e135t3f80"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

/* harmony default export */ var HelpGrid_HelpGrid = (HelpGrid);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 93 modules
var Brandbook = __webpack_require__(52065);
;// CONCATENATED MODULE: ./src/views/Help/data/data.ts

var data = [{
  title: "Technical Docs",
  description: "Find the answers to any of your specific technical questions about all features of the Segment CDP platform.",
  icon: Brandbook/* DocumentIcon */.$l,
  href: "https://segment.com/docs/",
  contentTypes: ["article", "guide"],
  topics: ["identity-resolution", "onboarding-resources", "tracking-best-practices"],
  roles: ["engineering", "marketing", "product"]
}, {
  title: "Segment University",
  description: "A hands-on video tutorial of how to use Segment, offering step-by-step instructions for: planning what to track, how to deploying tracking, configuring integrations, managing traits & audiences, and more.",
  icon: Brandbook/* LearningIcon */.SV,
  href: "https://university.segment.com/",
  contentTypes: ["article", "course", "guide", "video"],
  topics: ["analytics", "identity-resolution", "onboarding-resources", "tracking-best-practices"],
  roles: ["analytics", "engineering", "marketing", "product"]
}, {
  title: "Analytics Academy",
  description: "Introduction to the wide world of analytics, including: how to choose metrics, a guide for choosing your stack (and how your stack should evolve), and how to build a data-driven company.",
  icon: Brandbook/* AnalyticsIcon */.Ie,
  href: "/academy/",
  contentTypes: ["article", "course", "guide"],
  topics: ["analytics", "onboarding-resources", "tracking-best-practices"],
  roles: ["analytics", "engineering", "marketing", "product"]
}, {
  title: "Recipes",
  description: "Looking for more ways to supercharge your stack with Segment and get more value from your data? Explore our cookbook of use-cases with step-by-step instructions of how to implement them.",
  icon: Brandbook/* GuidesIcon */.Yu,
  href: "/recipes/",
  contentTypes: ["article", "guide"],
  topics: ["analytics", "tracking-best-practices"],
  roles: ["analytics", "engineering", "marketing", "product"]
}, {
  title: "Technical Support",
  description: "Can't find your answer elsewhere? Submit a ticket with our Technical Support team.",
  icon: Brandbook/* ToolIcon */.Ec,
  href: "https://segment.com/help/contact/",
  contentTypes: [],
  topics: ["analytics", "identity-resolution", "onboarding-resources", "tracking-best-practices"],
  roles: ["analytics", "engineering", "marketing", "product"]
}, {
  title: "Demo",
  description: "Connect with a Segment expert from our Sales team who can share more about the product and answer any questions you have.",
  icon: Brandbook/* MessageIcon */.P$,
  href: "/demo/",
  contentTypes: [],
  topics: ["analytics"],
  roles: ["analytics", "engineering", "marketing", "product"]
}, {
  title: "Events",
  description: "Join Segment experts for industry insights and best practices advice, and check out recordings of past events.",
  icon: Brandbook/* UserIcon */.tB,
  href: "/events/",
  contentTypes: ["video", "webinar"],
  topics: ["analytics", "tracking-best-practices"],
  roles: ["analytics", "engineering", "marketing", "product"]
}, {
  title: "Blog",
  description: "The Segment team's latest thinking on all things data, product, marketing, and growth.",
  icon: Brandbook/* UnderstandingIcon */.A4,
  href: "https://segment.com/blog/",
  contentTypes: [],
  topics: [],
  roles: []
}, {
  title: "Status",
  description: "Follow live monitoring of Segment\u2019s uptime and status updates on any identified performance issues.",
  icon: Brandbook/* PlugIcon */.BW,
  href: "https://status.segment.com/",
  contentTypes: [],
  topics: [],
  roles: []
}, {
  title: "Growth Masters",
  description: "Learn how to build better products for your customers and grow your business. This collection of on-demand video lessons are led by industry thought leaders and deliver actionable recommendations on topics like user research, experimentation, onboarding, and more.",
  icon: Brandbook/* LaunchIcon */.bu,
  href: "https://growth.segment.com/",
  contentTypes: ["course", "video"],
  topics: ["analytics"],
  roles: ["analytics", "engineering", "marketing", "product"]
}];
/* harmony default export */ var data_data = (data);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
;// CONCATENATED MODULE: ./src/views/Help/components/NeedSomethingElse/NeedSomethingElse.tsx


function NeedSomethingElse_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var NeedSomethingElse_copy = {
  heading: "Need something else?",
  description: "Submit a ticket to our support team for additional help."
};
var NeedSomethingElse_button = {
  text: "Open a ticket",
  href: "https://segment.com/help/contact/"
};

var NeedSomethingElse = function NeedSomethingElse() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NeedSomethingElse_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: NeedSomethingElse_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: NeedSomethingElse_copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
        size: "large",
        color: "primary",
        variant: "filled",
        tag: "a",
        href: (0,getAbsoluteUrl/* default */.Z)(NeedSomethingElse_button.href, pageConfig),
        children: NeedSomethingElse_button.text
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  });
};

var NeedSomethingElse_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e13muejx2"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";overflow-y:auto;overflow-x:hidden;padding-top:40px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:160px;}" + ( true ? "" : 0));

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e13muejx1"
} : 0)( true ? {
  name: "aem9ln",
  styles: "display:grid;justify-items:center;row-gap:40px;padding:0 24px"
} : 0);

var StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e13muejx0"
} : 0)("width:100%;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{width:unset;}" + ( true ? "" : 0));

/* harmony default export */ var NeedSomethingElse_NeedSomethingElse = (NeedSomethingElse);
;// CONCATENATED MODULE: ./src/views/Help/data/useFilters.ts


function useFilters_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFilters_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFilters_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFilters_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var filtersReducer = function filtersReducer(filters, nextFilters) {
  return useFilters_objectSpread(useFilters_objectSpread({}, filters), nextFilters);
};

var useFilters = function useFilters() {
  return (0,react.useReducer)(filtersReducer, {
    contentType: null,
    topic: null,
    role: null
  });
};

/* harmony default export */ var data_useFilters = (useFilters);
;// CONCATENATED MODULE: ./src/views/Help/data/useFilteredData.ts


var satisfiesFilter = function satisfiesFilter(record, filters, filter) {
  var filterValue = filters[filter];
  var recordKey = "".concat(filter, "s");
  var recordAttributes = record[recordKey];
  return filterValue === null || recordAttributes.includes(filterValue);
};

var useFilteredData = function useFilteredData(data, filters) {
  return (0,react.useMemo)(function () {
    return data.filter(function (record) {
      return satisfiesFilter(record, filters, "contentType") && satisfiesFilter(record, filters, "role") && satisfiesFilter(record, filters, "topic");
    });
  }, [data, filters]);
};

/* harmony default export */ var data_useFilteredData = (useFilteredData);
// EXTERNAL MODULE: ./src/views/Help/assets/OgHelp.png
var OgHelp = __webpack_require__(27485);
var OgHelp_default = /*#__PURE__*/__webpack_require__.n(OgHelp);
;// CONCATENATED MODULE: ./src/views/Help/Help.tsx




















var contentTypeOptions = [{
  value: "all",
  text: "All"
}, {
  value: "article",
  text: "Articles"
}, {
  value: "course",
  text: "Courses"
}, {
  value: "guide",
  text: "Guides"
}, {
  value: "video",
  text: "Videos"
}, {
  value: "webinar",
  text: "Webinars"
}];
var topicOptions = [{
  value: "all",
  text: "All"
}, {
  value: "analytics",
  text: "Analytics"
}, {
  value: "identity-resolution",
  text: "Identity resolution"
}, {
  value: "onboarding-resources",
  text: "Onboarding resources"
}, {
  value: "tracking-best-practices",
  text: "Tracking best practices"
}];
var roleOptions = [{
  value: "all",
  text: "All"
}, {
  value: "analytics",
  text: "Analytics"
}, {
  value: "engineering",
  text: "Engineering"
}, {
  value: "marketing",
  text: "Marketing"
}, {
  value: "product",
  text: "Product"
}];
var filterSelects = [{
  id: "contentType",
  placeholder: "Type of content",
  options: contentTypeOptions
}, {
  id: "topic",
  placeholder: "Topic",
  options: topicOptions
}, {
  id: "role",
  placeholder: "Role",
  options: roleOptions
}];

var Help = function Help() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useState = (0,react.useState)(""),
      query = _useState[0],
      setQuery = _useState[1];

  var _useFilters = data_useFilters(),
      _useFilters2 = (0,slicedToArray/* default */.Z)(_useFilters, 2),
      filters = _useFilters2[0],
      setFilters = _useFilters2[1];

  var filteredData = data_useFilteredData(data_data, filters);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Help | Twilio Segment",
      pageDescription: "Twilio Segment is trusted by thousands of companies as their Customer Data Platform. Collect user data with one API and send it to hundreds of tools or a data warehouse.",
      pageOG: (OgHelp_default()),
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {
        query: query,
        onQueryChange: setQuery
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filters_Filters, {
          children: filterSelects.map(function (_ref) {
            var id = _ref.id,
                placeholder = _ref.placeholder,
                options = _ref.options;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FilterSelect_FilterSelect, {
              id: id,
              placeholder: placeholder,
              options: options,
              onSelect: function onSelect(_ref2) {
                var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 1),
                    selectedOption = _ref3[0];

                return setFilters((0,defineProperty/* default */.Z)({}, id, selectedOption.value === "all" ? null : selectedOption.value));
              }
            }, id);
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HelpGrid_HelpGrid, {
          data: filteredData
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NeedSomethingElse_NeedSomethingElse, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1t4cu0u0"
} : 0)("background-color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Help_Help = (Help);
;// CONCATENATED MODULE: ./src/pages/help.tsx



var help_Help = function Help() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Help_Help, {});
};

/* harmony default export */ var help = (help_Help);

/***/ }),

/***/ 54086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SearchBar; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 93 modules
var Brandbook = __webpack_require__(52065);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/matcha/components/Loader/index.ts
var Loader = __webpack_require__(37438);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/SearchBar/SearchBar.tsx


var _excluded = ["name", "id", "placeholder", "required", "error", "value", "expanded", "onChange", "onClear", "disabled", "appearance", "isLoading", "dataHook"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var SearchBar = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var name = _ref.name,
      id = _ref.id,
      placeholder = _ref.placeholder,
      required = _ref.required,
      error = _ref.error,
      value = _ref.value,
      expanded = _ref.expanded,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      disabled = _ref.disabled,
      appearance = _ref.appearance,
      isLoading = _ref.isLoading,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
    type: "search",
    icon: isLoading ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {
      size: "small"
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* SearchIcon */.W1, {}),
    resetable: true,
    name: name,
    id: id,
    placeholder: placeholder,
    required: required,
    disabled: disabled,
    value: value,
    onChange: onChange,
    onClear: onClear,
    appearance: appearance,
    error: error,
    ref: ref,
    expanded: expanded,
    dataHook: dataHook
  }, rest));
});
;// CONCATENATED MODULE: ../../libs/matcha/components/SearchBar/index.ts


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 1959:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A helper function to generate the path to an image from Contentful.
 * @param props.src - The path to the image
 * @param props.width - The width of the image
 * @param props.quality - The quality of the image
 * @returns The path to the image with the width and quality parameters
 */
var contentfulImageLoader = function contentfulImageLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  return "".concat(src, "?w=").concat(width, "&q=").concat(quality || 75);
};

/* harmony default export */ __webpack_exports__["Z"] = (contentfulImageLoader);

/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 61683:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help",
      function () {
        return __webpack_require__(71922);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27485:
/***/ (function(module) {

module.exports = "/_next/static/images/OgHelp-ff87994566e3053d0d9dd8539253be3b.png";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,7929,1382,4136,8392,2073,7096,2429,7303,4488,948,8187,442,4881,2065,9600,9774,2888,179], function() { return __webpack_exec__(61683); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);